$(document).ready(function(){

  // Toggle swatches on click
  $(document).on('click', '.product-form__input .product-card__swatches.custom-selector .swatch-color-selected', function() {
    $('.product-form__input .product-card__swatches.custom-selector .swatches').not($(this).siblings("ul.swatches")).removeClass('active');
    $('.product-form__input .product-card__swatches.custom-selector').not($(this).parents(".custom-selector")).removeClass('active');

    $(this).siblings("ul.swatches").toggleClass("active");
    $(this).parents(".custom-selector").toggleClass("active");
  });

  // Footer add all products in bundle
  $('body').on('click', ".product-card__footer #product_card_bundle", async function (e) {
    e.preventDefault();

    const $bundleWrapper = $(this).closest('.products-list');
    if ($bundleWrapper.length === 0) return;

    const $allForms = $bundleWrapper.find('form[is="product-form"]');
    const availableForms = [];

    $allForms.each(function () {
      const $form = $(this);
      const $submitButton = $form.find('button[type="submit"]');
      const isSoldOut = $submitButton.prop('disabled') || $submitButton.text().toLowerCase().includes('sold out') || $submitButton.find('span').text().toLowerCase().includes('sold out');
      const variantId = $form.find('input[name="id"]').val();

      if (variantId && !isSoldOut) availableForms.push({ form: $form, variantId });
    });

    if (availableForms.length === 0) {
      alert('All products in this bundle are sold out!');
      return;
    }
var page_title = parseInt($('.page-title-jtpl').attr('page-title-jtpl'));
var properties = {};
 if (!isNaN(page_title) && page_title >= 6 && page_title <= 10) {
    properties[`top ${page_title} products`] = true;
  } else {
    properties = { "top products": true };
  }

    const items = availableForms.map(item => ({ id: item.variantId, quantity: 1, properties }));
console.log("items",items)
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items })
      });

      if (!response.ok) {
        const errorData = await response.json();
        alert('Error adding items to cart: ' + (errorData.description || 'Unknown error'));
        return;
      }

      const cartResponse = await response.json();
      document.dispatchEvent(new CustomEvent('product-ajax:added', {
        bubbles: true,
        detail: { product: cartResponse, items: items }
      }));

      const cart = await fetch('/cart.js').then(r => r.json());
      $('#CartCount').text(cart.item_count).removeAttr('hidden');

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
      }
setTimeout(() => {
      initializeSwiper();
}, 2000);
    } catch (error) {
    }
  });

  const swiperNav = new FoxTheme.Carousel('.tabs__nav-wrap.swiper', {
    slidesPerView: 1,
    spaceBetween: 0,
    loop:true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      0: { slidesPerView: 1 },
      768: { slidesPerView: 3 },
      1024: { slidesPerView: 4 },
    }
  });
  swiperNav && swiperNav.init();

// swiperNav.slider.on('slideChangeTransitionEnd', function () {
  
//   // Get the active slide
//   const activeSlide = swiperNav.slider.slides[swiperNav.slider.activeIndex];
//   if (!activeSlide) {
//     return;
//   }

//   // Find tab button — works if .tabs__tab is itself the slide OR nested inside
//   let activeTabButton = activeSlide.classList.contains('tabs__tab')
//     ? activeSlide
//     : activeSlide.querySelector('.tabs__tab');

//   if (activeTabButton) {
//     activeTabButton.click(); // Trigger same tab logic
//   } else {
//     console.warn('Still no .tabs__tab found in active slide.');
//   }
// });


swiperNav.slider.on('slideChange', function () {
  const activeSlide = swiperNav.slider.slides[swiperNav.slider.activeIndex];
  if (!activeSlide) return;

  let activeTabButton = activeSlide.classList.contains('tabs__tab')
    ? activeSlide
    : activeSlide.querySelector('.tabs__tab');

  if (activeTabButton) {
    activeTabButton.click();
  }
});



 document.querySelectorAll('.tabs__tab').forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault(); 
      swiperNav.slider.update();

      const tabPanel = document.querySelector('.tabs__panel');
      if (!tabPanel) return;

      tabPanel.querySelectorAll('.tabs__content').forEach(content => {
        content.style.display = 'none';
      content.classList.remove('active');
      });

      const matchingContent = tabPanel.querySelector(`#tab-${button.id}`);
      if (matchingContent) {
        matchingContent.style.display = 'block';
        matchingContent.classList.add('active');
      }

      document.querySelectorAll('.tabs__tab').forEach(tab => tab.classList.remove('active'));
      button.classList.add('active');
    });
  });


  // Swatch click
  $(document).on('click', '.swatches li[data-variant-id]', function(event) {
    const $changedElement = $(this);
    const variantId = $changedElement.attr('data-variant-id');
    const variantImg = $changedElement.attr('data-src-img');
    const inventory = parseInt($changedElement.attr('data-inventory'), 10);
    console.log("+++variantImg+++++++",variantImg);
    // image change according variant
    $(this).parents(".product-bundle-card").find(".product-bundle-card__image img").attr("src",variantImg) 
    // end image change according variant
    $("ul.swatches").removeClass("active");
    $changedElement.parents(".custom-selector").toggleClass("active");

    const $parentContainer = $changedElement.closest('.product-card__info-wrapper');
    const $form = $parentContainer.find('form.main-product-form');
    const $button = $form.find('button[type="submit"]');

    if ($form.length) {
      const $variantInput = $form.find('input.product-variant-id');
      if ($variantInput.length) $variantInput.val(variantId);
    }

    if (inventory <= 0) {
      $button.attr('disabled', true).text('Sold Out');
    } else {
      $button.removeAttr('disabled').text('Add to Cart');
    }

    updateSelectedSwatch(this, variantId);
  });

  // Selected swatch update function
  function updateSelectedSwatch(clickedSwatch, variantId) {
    const swatchContainer = clickedSwatch.closest('.product-card__swatches');
    if (!swatchContainer) return;

    const selectedElement = swatchContainer.querySelector('.swatch-color-selected .swatch-color');
    const clickedSwatchLink = clickedSwatch.querySelector('.swatch-color');

    if (clickedSwatchLink && selectedElement) {
      const bgColor = clickedSwatchLink.style.getPropertyValue('--swatch-background');
      const bgImage = clickedSwatchLink.style.getPropertyValue('background-image');
      selectedElement.style.setProperty('--swatch-background', bgColor);
      selectedElement.style.setProperty('background-image', bgImage);
    }

    const optionValue = swatchContainer.querySelector('.option-value');
    const clickedValue = clickedSwatch.querySelector('.option-value');
    if (optionValue && clickedValue) optionValue.textContent = clickedValue.textContent;

    const tooltip = swatchContainer.querySelector('.tooltip');
    const clickedTooltip = clickedSwatch.querySelector('.visually-hidden');
    if (tooltip && clickedTooltip) tooltip.textContent = clickedTooltip.textContent;

    const selectedLink = swatchContainer.querySelector('.swatch-color-selected a');
    const clickedLink = clickedSwatch.querySelector('a');
    if (selectedLink && clickedLink) selectedLink.href = clickedLink.href;

    const selectedSwatchValue = swatchContainer.closest('.product__block--variant_picker')
                                      .querySelector('[data-selected-swatch-value]');
                                      console.log("selectedSwatchValue>>>>>>>>>>>>>>",selectedSwatchValue);
    if (selectedSwatchValue && clickedValue) selectedSwatchValue.textContent = clickedValue.textContent.trim();
  }

}); // <-- close document.ready
